import React from 'react';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary,} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';

import Grid from 'material-ui/Grid';

import {Done, Close} from 'material-ui-icons';

import EditationAircraftInstances from './EditationAircraftInstances';
import Files from '../../Files';

import tsl from '../../../tsl';
import Immutable from 'immutable';
import { Select, TextField, withValidatedInputs, Validations } from '../../../../components/forms';
import { getWeightUnit } from 'utils/client';

class Editation extends React.Component {
    state = {
        panelIndex: 0,
        entity: {},
    };

    togglePanel = (panelIndex) => () => {
        this.setState({
            panelIndex: (panelIndex == this.state.panelIndex) ? null : panelIndex
        })
    }

    handleChange = event => {
        let entity = this.state.entity;
        entity[event.target.name] = event.target.value;

        this.setState({entity: entity});
    }
    
    handleChangeRelation = event => {
        let prop = event.target.name;

        let entity = this.state.entity;
        entity[prop] = { id: event.target.value };

        this.setState({entity: entity});
    }

    handleChangeAircrafts = (aircrafts) => {
        let newEntity = this.state.entity;
        
        newEntity.aircrafts = aircrafts;
        
        this.setState({
            entity: newEntity
        });
    }

    handleFilesChange = (files) => {
        let entity = this.state.entity;
        entity.files = files;
        this.setState({
            entity: entity
        });
    }

    handleSave = () => {
        if (this.props.trySubmit()) {
          this.props.saveEntity(this.state.entity);
        }
    }

    handleDelete = () => {
        this.props.deleteEntity(this.state.entity);
    }

    handleClose = () => {
        this.setEntity(this.props.entityData); // reset entity
        this.props.onClose();
        this.props.resetFormErrors();
    };

    setEntity = (entityData) => {
      // create deep copy
      const entity = Immutable.fromJS(entityData).toJS();

      this.setState({
        entity,
      });
    };

    componentWillReceiveProps(newProps) {
      if (newProps.entityData != this.props.entityData) {
        this.setEntity(newProps.entityData);
      }
    }

    renderEntityInformationForm() {
        return (
            <Grid container spacing={24}>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="type">{tsl('aircrafts.edit.aircraft_model_type')}</InputLabel>
                      <Select
                        formActions={this.props.formActions}
                        required
                        name="type"
                        value={this.state.entity && this.state.entity.type ? this.state.entity.type.id : 0}
                        onChange={this.handleChangeRelation}
                      >
                        <MenuItem value={0}>{"- " + tsl('aircrafts.edit.select_type') + "-"}</MenuItem>
                        <MenuItem value={1}>Plane</MenuItem>
                        <MenuItem value={2}>Helicopter</MenuItem>
                      </Select>
                    </FormControl>
                    <br /><br />
                    <TextField
                        formActions={this.props.formActions}
                        required
                        fullWidth
                        id="name"
                        label={tsl('aircrafts.edit.model_name')}
                        name="name"
                        value={this.state.entity.name || ''}
                        onChange={this.handleChange}
                    />
                    <br /><br />
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="passengers_capacity"
                        label={tsl('aircrafts.edit.passengers_capacity')}
                        name="passengers_capacity"
                        value={this.state.entity.passengers_capacity || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">{tsl('aircrafts.edit.capacity_input_suffix')}</InputAdornment>}}
                    />
                    <br /><br />
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="range"
                        label={tsl('aircrafts.edit.max_range')}
                        name="range"
                        value={this.state.entity.range || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">km</InputAdornment>}}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="weight_empty"
                        label={tsl('aircrafts.edit.weight_empty')}
                        name="weight_empty"
                        value={this.state.entity.weight_empty || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">{getWeightUnit()}</InputAdornment>}}
                    />
                    <br /><br />
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="weight_max"
                        label={tsl('aircrafts.edit.weight_max')}
                        name="weight_max"
                        value={this.state.entity.weight_max || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">{getWeightUnit()}</InputAdornment>}}
                    />
                    <br /><br />
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="weight_fuel_max"
                        label={tsl('aircrafts.edit.weight_fuel_max')}
                        name="weight_fuel_max"
                        value={this.state.entity.weight_fuel_max || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">{getWeightUnit()}</InputAdornment>}}
                    />
                    <br /><br />
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="useful_load"
                        label={tsl('aircrafts.edit.useful_load')}
                        name="useful_load"
                        value={this.state.entity.useful_load || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">{getWeightUnit()}</InputAdornment>}}
                    />
                </Grid>
            </Grid>
        );
    }

    render() {
        return (
            <div className="w-100">

                <Button fab raised color="accent"
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={() => {this.handleSave()}}
                >
                    <Done />
                </Button>

                <Button fab raised
                    className="jr-fab-btn jr-btn-fab-sm text-white"
                    style={{position: "fixed", bottom: 5, right: 70, zIndex: 9999}}
                    onClick={this.handleClose}
                >
                    <Close />
                </Button>

                <ExpansionPanel expanded={this.state.panelIndex === 0} onChange={this.togglePanel(0)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('aircrafts.edit.aircraft_model_details')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        {this.renderEntityInformationForm()}
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel expanded={this.state.panelIndex === 1} onChange={this.togglePanel(1)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('aircrafts.edit.instances')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>

                        <EditationAircraftInstances
                            formActions={this.props.formActions}
                            aircrafts={this.state.entity && this.state.entity.aircrafts ? this.state.entity.aircrafts : []}
                            onChange={this.handleChangeAircrafts}
                        />
                    
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel expanded={this.state.panelIndex === 2} onChange={this.togglePanel(2)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('aircrafts.edit.files')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Files files={this.state.entity ? this.state.entity.files : []} onChange={this.handleFilesChange} />
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                
                {/* show delete section, only when entity is already saved (has ID) */}
                {!this.state.entity.id ? null : 
                    <div>
                        <br />

                        <ExpansionPanel expanded={this.state.panelIndex === 3} onChange={this.togglePanel(3)}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                                <Typography>{tsl('aircrafts.edit.delete_panel')}</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{color: "red"}}>

                                <h2>{tsl('aircrafts.delete.confirmation')}</h2>
                                
                                <Button onClick={this.handleDelete}>{tsl('aircrafts.delete.yes_btn')}</Button>
                            
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </div>
                }

            </div>
        );
    }
}

export default withValidatedInputs(Editation);


// WEBPACK FOOTER //
// ./app/used/aircrafts/routes/Editation.js